import { FormEvent } from 'react';
import {
  ArrowBack,
  ArrowDownward,
  ArrowForward,
  ArrowUpward,
} from '@material-ui/icons';
import { Button } from '../Button/NewButton';

interface Props {
  activeStep: number;
  canSubmit: boolean;
  completedSteps: number[];
  expandAll: boolean;
  onChangeStep(step: number): void;
  orientation: 'vertical' | 'horizontal';
  onSkipToEnd(): void;
  onSubmit(event: FormEvent<HTMLFormElement>): void;
  stepIndex: number;
  steps: StepDefinition[];
  submitButton: string;
}

export const StepButtons = ({
  activeStep,
  canSubmit,
  completedSteps,
  expandAll,
  onChangeStep,
  orientation,
  onSkipToEnd,
  onSubmit,
  stepIndex,
  steps,
  submitButton,
}: Props) => {
  const isFirst = stepIndex === 0;
  const isLast = stepIndex === steps.length - 1;

  const backButton = () =>
    !isFirst && !expandAll ? (
      <Button
        endIcon={orientation === 'vertical' ? <ArrowUpward /> : undefined}
        startIcon={orientation === 'horizontal' ? <ArrowBack /> : undefined}
        width={125}
        onClick={() => onChangeStep(activeStep - 1)}
      >
        Back
      </Button>
    ) : null;

  const nextButton = () =>
    !expandAll ? (
      <Button
        endIcon={
          isLast ? (
            <ArrowForward />
          ) : orientation === 'vertical' ? (
            <ArrowDownward />
          ) : (
            <ArrowForward />
          )
        }
        width={185}
        theme={isLast ? 'action' : undefined}
        onClick={(event: FormEvent<HTMLFormElement>) =>
          isLast ? onSubmit(event) : onChangeStep(activeStep + 1)
        }
        disabled={
          isLast
            ? completedSteps.length !== steps.length
            : !steps[stepIndex].validation
        }
      >
        {isLast ? submitButton : steps[stepIndex + 1].label}
      </Button>
    ) : isLast ? (
      <Button
        endIcon={<ArrowForward />}
        width={185}
        theme="action"
        onClick={(event: FormEvent<HTMLFormElement>) => onSubmit(event)}
        disabled={completedSteps.length !== steps.length}
      >
        {submitButton}
      </Button>
    ) : null;

  const skipButton = () =>
    canSubmit &&
    !isLast &&
    activeStep < steps.length - 2 &&
    steps.length > 2 ? (
      <Button
        endIcon={<ArrowDownward />}
        width={185}
        onClick={() => {
          onChangeStep(steps.length - 1);
          onSkipToEnd();
        }}
      >
        {steps[steps.length - 1].label}
      </Button>
    ) : null;

  return (
    <div className="flex flex-row flex-wrap items-center justify-center gap-2 p-4">
      {backButton()}
      {nextButton()}
      {skipButton()}
    </div>
  );
};
